import router from '@/router'
import { putHistory } from '@api/train'

const common = {
  state: {
    _THERAPY_STATUS_: 'ready',
    curTherapy: { name: 'AN', fullName: '脱抑制' },
    curConfig: {
      // 设置由 currentTherapy components 注入
    },
    curData: {
      // '正确次数': 0,
      // '错误次数': 0
    },
    globalConfig: {
      Sight: [],
      Vergence: [],
      Eyemovement: [],
    },
    preRunningTime: 0,
    result: {
      runningTime: 0,
    },
    remainTime: 5,
    duration: 5,
    overDialogVisible: false,
  },
  mutations: {

    /**
     * 训练全局状态.
     * @param {String} status
     * @description:
     * palying - 进行中
     * pending - 待机
     * pause - 暂停
     * ready - 就绪
     * ending - 结束弹窗
     */
    updateStatus: (state, status) => {
      state._THERAPY_STATUS_ = status
      window._THERAPY_STATUS_ = status
      localStorage.setItem('_THERAPY_STATUS_', status)
    },
    // 设置 当前训练
    setCurrentTherapy: (state, therapy) => {
      if (window.therapy && state._THERAPY_STATUS_ === 'playing') {
        window.therapy.gameClose()
      }
      state._THERAPY_STATUS_ = 'ready'
      state.curTherapy = therapy
    },
    // 设置 训练 局部设置
    setCurConfig: (state, config) => {
      Object.assign(state.curConfig, config)
    },
    // 清除 训练 局部设置
    clearCurConfig: state => {
      state.curConfig = {}
    },
    // 设置 训练 全局设置
    setGlobalConfig: (state, config) => {
      state.globalConfig = config
    },
    // 设置 训练 数据
    setCurData: (state, data) => {
      state.curData = { ...state.curData, ...data }
      // extend(state.curData, data)
      // Object.assign(state.curData, data)
    },
    // 清除 训练 局部设置
    clearCurData: state => {
      state.curData = {}
    },

    // 设置 训练 剩余时间
    setRemainTime: (state, data) => {
      state.duration = data
      console.log(state.duration, 'state.duration')
    },

    setTherapyResult: (state, result) => {
      state.result = result
    },

    updateTherapyConfig: (state, config) => {
      state = config
      console.log('therapy/State', state)
      // Object.assign(state.sight, config)
    },
  },
  actions: {
    StartTherapy: {
      root: true,
      async handler({ commit }, train) {
        await commit('setCurrentTherapy', train)
        if (train.category === 'VTX') {
          router.push('/therapy')
        } else {
          router.push('/rs')
        }
      },
    },
    StartVTX: {
      root: true,
      handler({ commit, state }) {
        import('@therapy/index.js').then(scenes => {
          const _scene = scenes[state.curTherapy.name]
          window.therapy.changeTherapy(
            _scene,
            state.curConfig,
            state.curTherapy.fullName
          )
          commit('updateStatus', 'playing')
        })
      },
    },
    UpdateTherapy: {
      root: true,
      async handler({ dispatch }, status) {
        if (status === 'playing') {
          dispatch('StartVTX', null, { root: true })
        }
      },
    },
    AsyncStart: {
      root: true,
      async handler({ commit, state }) {
        let path = `@therapy/${state.curTherapy.name}/program/index.js`
        let scene = await import(path)

        window.therapy.changeTherapy(
          scene.default,
          state.curConfig,
          state.curTherapy.fullName
        )
        commit('updateStatus', 'playing')
      },
    },
    EndTherapy: {
      root: true,
      async handler({ state, rootState, commit }) {
        window.therapy.therapyClose()
        // 结束中， 弹出结束窗口
        commit('updateStatus', 'ending')
      },
    },
    PutHistory: {
      root: true,
      async handler({ state, rootState, commit }) {
        if (
          rootState.user.curPatient.uid &&
          state._THERAPY_STATUS_ === 'ending'
        ) {
          let obj = {
            name: state.curTherapy.fullName,
            settings: state.curConfig,
            result: state.curData,
          }
          const data = {
            type: 'train',
            uid: rootState.user.curPatient.uid,
            result: JSON.stringify(obj),
          }
          putHistory(data)
        }
      },
    },
  },
  getters: {},
}

export default common
